import React, { useRef } from 'react';

import { ButtonComponent } from 'aplazame-design-system';
import {
    Heading,
    Container,
    Row,
    Col,
    Text,
    className,
} from 'soluble-design-system-base';

import sectionStyle from '../../scss/section.module.scss';
import colorStyle from '../../scss/color.module.scss';
import textStyle from '../../scss/text.module.scss';

export default function DescriptionSection({
    colorScheme,
    buttons,
    text,
    title,
    titleTag,
    titleClassName,
    textClassName,
    wrapperClassName,
}) {
    const isFirstLoad =
        typeof window !== 'undefined' &&
        !window.document.body.dataset.navigating;
    const firstDelay = isFirstLoad ? 300 : 100;

    const buttonRef = useRef();

    return (
        <section
            {...className(
                [
                    colorStyle[`bg--${colorScheme}`],
                    'pt-10',
                    'pb-10',
                    'd-lg-flex align-items-lg-center',
                    wrapperClassName ?? '',
                ].join(' '),
            )}>
            <div
                data-sal="fade"
                data-sal-easing="ease-out-quart"
                {...className(`${sectionStyle.bg} ${colorStyle.bg}`)}
                style={{
                    '--sal-delay': `${firstDelay}ms`,
                    left: '0px',
                    right: '0px',
                }}
            />
            <Container>
                <Row>
                    <Col
                        col={{
                            xs: 12,
                            lg: 8,
                        }}
                        offset={{ lg: 2 }}>
                        <Heading
                            tag={titleTag}
                            className={`h2 mb-3 mb-lg-5 ${textStyle.gradual} ${
                                titleClassName ?? ''
                            }`}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                            style={{
                                '--sal-delay': `${firstDelay + 300}ms`,
                            }}>
                            {title}
                        </Heading>
                        <Text
                            tag="div"
                            className={`${
                                textClassName ? textClassName : 'h3'
                            }`}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                            style={{
                                '--sal-delay': `${firstDelay + 600}ms`,
                            }}>
                            {text}
                        </Text>
                        {buttons && buttons.length ? (
                            <div
                                ref={buttonRef}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                                style={{
                                    '--sal-delay': `${firstDelay + 900}ms`,
                                }}
                                {...className(`text-left text-lg-center mt-5`)}>
                                <ButtonComponent
                                    buttons={buttons}
                                    blockMobile={false}
                                    buttonClassName={`mb-3 mb-lg-0 mr-lg-3 mr-xl-5`}
                                />
                            </div>
                        ) : null}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
